import {
  setAmeyoDowntimeStatus,
  setAmeyoDowntimeTooltipVisiblity,
  setAmeyoWidgetVisibility
} from '@cp/reducers/ameyoSlice';
import { AMEYO_DOWNTIME_STATUS } from '@cp/components/Ameyo/constants';
import { Dispatch } from 'react';
import { GenericObject } from '@cp/src/types/CommonConstans';

export const ameyoDowntimeEventProcessor = (payload: GenericObject, dispatch: Dispatch<any>) => {
  if (payload.notificationTemplate.templateName === 'AMEYO_CAMPAIGN_UP') {
    dispatch(setAmeyoDowntimeStatus(AMEYO_DOWNTIME_STATUS.UP));
    dispatch(setAmeyoDowntimeTooltipVisiblity(true));
    return;
  } else if (payload.notificationTemplate.templateName === 'AMEYO_LOW_CALLS') {
    dispatch(setAmeyoDowntimeStatus(AMEYO_DOWNTIME_STATUS.LESS_CALLS));
    dispatch(setAmeyoDowntimeTooltipVisiblity(false));
    dispatch(setAmeyoWidgetVisibility(true));
  } else if (payload.notificationTemplate.templateName === 'AMEYO_NORMAL_CALLS') {
    dispatch(setAmeyoDowntimeStatus(AMEYO_DOWNTIME_STATUS.UP));
    dispatch(setAmeyoDowntimeTooltipVisiblity(true));
  } else {
    dispatch(setAmeyoDowntimeStatus(AMEYO_DOWNTIME_STATUS.DOWN));
    dispatch(setAmeyoDowntimeTooltipVisiblity(false));
    dispatch(setAmeyoWidgetVisibility(true));
  }
};
